// when a user selects a different currency in a form,
// updates all currencies on the page.
// for this to work, the select must have the js-currency-select class
// and all the currencis displayed elsewehre must be in their own element
// with the class js-currency-display.
// see DefaultFormBuilder#price_field and views/shared/_currency_display.html.erb

export function updateCurrencyDisplays() {
  document
    .querySelectorAll('.js-currency-select')
    .forEach((input) => updateCurrencies(input as HTMLInputElement));
}

export function setupUpdateCurrencyDisplays() {
  document.addEventListener('change', (e) => {
    const el = e.target as HTMLInputElement;
    if (!el || !el.matches('.js-currency-select')) {
      return;
    }
    updateCurrencies(el);
  });
  updateCurrencyDisplays();
}

function updateCurrencies(el: HTMLInputElement): void {
  var currency = el.value;
  const currencyElements = document.querySelectorAll(
    '.js-currency-display',
  ) as NodeListOf<HTMLElement>;

  currencyElements.forEach((el) => (el.innerText = currency));
}
